import { ApplicationDataBaseField } from './ApplicationDataBaseField';
import { Controller } from 'react-hook-form';
import { DateInput3 } from '@blueprintjs/datetime2';
import { ApplicationDataFormFieldPath } from '../ApplicationDataForm/ApplicationDataFormSchema';
import { ApplicationDataFieldCommonProps } from './types';

function getDateFormat() {
  const format = new Intl.DateTimeFormat(navigator.language).formatToParts(
    new Date(),
  );

  return format
    .map((part) => {
      switch (part.type) {
        case 'day':
          return 'dd';
        case 'month':
          return 'MM';
        case 'year':
          return 'yyyy';
        default:
          return part.value;
      }
    })
    .join('');
}

function defaultFormatter(value: unknown) {
  const isValidDate = value && !isNaN(Date.parse(String(value)));

  return isValidDate ? new Date(String(value)).toLocaleDateString() : '-';
}

interface ApplicationDataDateFieldProps
  extends ApplicationDataFieldCommonProps {
  name: ApplicationDataFormFieldPath;
  formatter?: (value: unknown) => string;
}

export const ApplicationDataDateField: React.FC<
  ApplicationDataDateFieldProps
> = ({ name, formatter = defaultFormatter, ...props }) => (
  <Controller
    name={name}
    render={({ field, fieldState }) => (
      <ApplicationDataBaseField
        errorMessage={
          fieldState.invalid ? fieldState.error?.message : undefined
        }
        valueElement={formatter(field.value as never)}
        inputElement={
          <DateInput3
            onChange={(selectedDate) =>
              selectedDate
                ? field.onChange(new Date(selectedDate).toISOString())
                : null
            }
            minDate={new Date('1900-01-01')}
            maxDate={new Date('2099-12-31')}
            value={field.value ?? null}
            inputProps={{
              inputRef: field.ref,
              onBlur: field.onBlur,
              onChange: (e) => !e.target.value && field.onChange(null),
            }}
            dateFnsFormat={getDateFormat()}
          />
        }
        {...props}
      />
    )}
  />
);
